import { ApiResponse } from '../types'
import { AxiosClient } from '../utils/clients'

export type GetQrCodeBillResponse = ApiResponse<QrCodeBill>
export type QrCodeBill = {
    postPaidBillUrl: string
    amountPayable: number
}

export type QrCodeBillRequest = { accountNumber: string; billPeriod: string }

export default class UbsRepository {
    private BASE_URL = 'https://api-ubs.gov-gh.com'

    constructor(private client: AxiosClient) {}

    async getQrCodeBill({ accountNumber, billPeriod }: QrCodeBillRequest) {
        const res = await this.client.get<GetQrCodeBillResponse>(
            `${this.BASE_URL}/ubsqrcodebill?accountNumber=${accountNumber}&billPeriod=${billPeriod}`,
        )

        return res.data.data
    }
}
